import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { initGoogleAnalytics, gaPageview } from "@/lib/analytics/ga";

/**
 * Laddar GA4 (gtag.js) i webbläsaren och skickar page_view vid SPA-navigering.
 * Respekterar samtycke: mätning aktiveras först när besökaren valt "alla".
 */
export function GoogleAnalytics() {
  const router = useRouter();

  useEffect(() => {
    
    initGoogleAnalytics();
    gaPageview();
    const unsub = router.subscribe("onResolved", () => {
      gaPageview();
    });
    return () => unsub();
  }, [router]);

  return null;
}
